import { ChevronLeft } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import shopApi from "../../../../api/shopApi";
import { useNotification } from "../../../../hooks/useNotification";
import AddFriendModal from "../AddFriendModal";
import { useDispatch } from "react-redux";

const GroupMemberSideBar = ({
  user,
  staffs,
  shop,
  group,
  members,
  setSelectedChat,
  setContacts,
  isOpen,
  setIsOpen,
}) => {
  const { addNotification } = useNotification();
  const [searchText, setSearchText] = useState("");
  const [isOpenAddFriendModal, setIsOpenAddFriendModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const searchRef = useRef(null);

  const handleAddFriendClick = async (uid, contentAddFriend) => {
    const checkExist = await shopApi.getContactByUid(shop._id, uid);
    if (checkExist.status === 1) {
      const shopRole = user.shopRoles?.find((sr) => sr.shopId === shop._id);
      const viewableStaffIds = shopRole?.viewMoreStaffIds ?? [];
      if (
        !user?.role?.includes("admin") &&
        user?._id !== shop?.staffId &&
        shopRole?.role !== "admin" &&
        checkExist.data[0]?.staffIds?.length > 0 &&
        !checkExist.data[0]?.staffIds?.includes(user._id) &&
        !checkExist.data[0]?.staffIds?.some((sId) =>
          viewableStaffIds.includes(sId),
        )
      ) {
        addNotification(
          `${checkExist.data[0]?.name} đang do ${
            staffs?.find((s) => s._id === checkExist.data[0]?.staffIds[0])?.name
          } quản lý`,
          -1,
        );
        return;
      }
      if ((checkExist.data[0]?.staffIds?.length ?? 0) === 0)
        await shopApi.updateContact({
          _id: checkExist.data[0]._id,
          staffIds: [user._id],
        });
    }
    const resAddFriend = await shopApi.addFriend({
      uid: uid,
      contentAddFriend: contentAddFriend,
      shopId: shop._id,
      zaloId: shop.zaloId,
      staffId: user?._id,
    });
    if (resAddFriend.status !== 1 && resAddFriend.message !== "Tự động kết bạn")
      addNotification(resAddFriend.message, resAddFriend.status);
  };

  const handleSendMessageClick = async (uid) => {
    const checkExist = await shopApi.getContactByUid(shop._id, uid);
    if (checkExist.status === 1) {
      const shopRole = user.shopRoles?.find((sr) => sr.shopId === shop._id);
      const viewableStaffIds = shopRole?.viewMoreStaffIds ?? [];
      if (
        !user?.role?.includes("admin") &&
        user?._id !== shop?.staffId &&
        shopRole?.role !== "admin" &&
        checkExist.data[0]?.staffIds?.length > 0 &&
        !checkExist.data[0]?.staffIds?.includes(user._id) &&
        !checkExist.data[0]?.staffIds?.some((sId) =>
          viewableStaffIds.includes(sId),
        )
      ) {
        addNotification(
          `${checkExist.data[0]?.name} đang do ${
            staffs?.find((s) => s._id === checkExist.data[0]?.staffIds[0])?.name
          } quản lý`,
          -1,
        );
        return;
      }
    }
    const res = await shopApi.updateProfileInfo({
      shopId: shop._id,
      uid: uid,
      staffId: user._id,
    });
    if (res.status === 1) {
      const resContacts = await shopApi.getContactByUids(shop._id, [uid], 1);
      if (resContacts.status === 1) {
        setContacts((pre) =>
          pre.map((x) => x.uid).includes(uid)
            ? pre
            : [...pre, resContacts.data[0]],
        );
        setSelectedChat(resContacts.data[0]);
      }
    }
  };

  useEffect(() => {
    if (isOpen) {
      searchRef?.current?.focus();
    }
  }, [isOpen]);

  return (
    <>
      <div className="flex items-center justify-between py-2 border-b border-gray-200 top-0">
        <button
          className="w-8 h-8 flex items-center justify-center text-gray-600 hover:bg-gray-100"
          onClick={() => setIsOpen(false)}
        >
          <ChevronLeft className="w-8 h-8 text-gray-600" />
        </button>
        <h2 className="h-11 flex items-center justify-center text-lg font-bold text-gray-800">
          Thành viên nhóm
        </h2>
        <div></div>
      </div>
      <div className="flex-1 overflow-y-auto">
        <div className="px-4 py-1">
          <p className="font-semibold mb-2">
            Danh sách thành viên ({members.length})
          </p>
          <div className="flex items-center mb-2">
            <input
              type="text"
              placeholder="Tìm kiếm thành viên"
              className="flex-1 px-2 py-1 border rounded focus:outline-none"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              ref={searchRef}
            />
          </div>
          <ul>
            {members
              .filter((x) =>
                x.name.toLowerCase().includes(searchText.toLowerCase()),
              )
              .sort((a, b) => {
                if (group.groupCreatorId === a.uid) return -1;
                if (group.groupCreatorId === b.uid) return 1;
                if (
                  group.groupAdminIds.includes(a.uid) &&
                  !group.groupAdminIds.includes(b.uid)
                )
                  return -1;
                if (
                  !group.groupAdminIds.includes(a.uid) &&
                  group.groupAdminIds.includes(b.uid)
                )
                  return 1;
                return 0;
              })
              .map((member) => (
                <li
                  key={member._id}
                  className="flex items-center justify-between py-2 border-b border-gray-200"
                >
                  <div className="flex items-center gap-2 w-2/3">
                    <img
                      src={member.avatar}
                      alt={member.name}
                      className="w-10 h-10 rounded-full"
                    />
                    <div className="flex flex-col overflow-hidden">
                      <span className="truncate font-medium text-gray-700">
                        {member.name}
                      </span>
                      <span className="text-sm text-gray-500">
                        {group.groupCreatorId === member.uid
                          ? `Trưởng ${
                              group.groupType === 1 ? " nhóm" : " cộng đồng"
                            }`
                          : group.groupAdminIds.includes(member.uid)
                            ? `Phó ${
                                group.groupType === 1 ? " nhóm" : " cộng đồng"
                              }`
                            : "Thành viên"}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col gap-1">
                    {member.uid !== shop.zaloId &&
                      !member.isFriend &&
                      !member.isRequested && (
                        <button
                          className="px-3 py-2 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 transition-colors"
                          onClick={() => {
                            setSelectedMember(member);
                            setIsOpenAddFriendModal(true);
                          }}
                        >
                          Kết bạn
                        </button>
                      )}
                    {member.uid !== shop.zaloId && (
                      <button
                        className="px-3 py-2 bg-gray-300 text-gray-700 text-xs rounded hover:bg-gray-400 transition-colors"
                        onClick={() => handleSendMessageClick(member.uid)}
                      >
                        Nhắn tin
                      </button>
                    )}
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
      <AddFriendModal
        isOpen={isOpenAddFriendModal}
        setIsOpen={setIsOpenAddFriendModal}
        shop={shop}
        addFriend={(contentAddFriend) =>
          handleAddFriendClick(selectedMember.uid, contentAddFriend)
        }
      />
    </>
  );
};

export default GroupMemberSideBar;
